export default __webpack_public_path__ + "static/media/casinoh24.5be9ac98.svg";